export const BasicLayout: React.FunctionComponent<{
    children: React.ReactNode
}> = ({ children }) => {
    return <div className="flex h-screen w-screen flex-col">{children}</div>
}

/** Fills the editor iframe without `100vw`, which would force a horizontal scrollbar. */
export const StorefrontPreviewLayout: React.FC<{
    children: React.ReactNode
}> = ({ children }) => {
    return <div className="w-full">{children}</div>
}
